import React from "react";

import ImgLeft from "../../UI/Section/ImgLeft/ImgLeft";
import ImgRight from "../../UI/Section/ImgRight/ImgRight";
import "./Services.css";
import imageSection1 from "../../../img/szatnia/Rysunek14.jpg";
import imageSection2 from "../../../img/szatnia/Galeria4.jpg";
import imageSection3 from "../../../img/szatnia/Rysunek7.jpg";
import imageSection4 from "../../../img/szatnia/Rysunek9.jpg";
import imageSection5 from "../../../img/szatnia/Rysunek11.jpg";
import imageSection6 from "../../../img/szatnia/Rysunek15.jpg";

const services = () => {
  return (
    <section id="services" className="py-3">
      <div className="container p-5">
        <ImgLeft
          image={imageSection1}
          header={"e-Szatnia samoobsługowa to:"}
          text={
            <ul>
              <li>usatysfakcjonowany klient, zadowolony petent</li>
              <li>komfort i higiena dla dwóch stron</li>
              <li>bezpieczeństwo i kontrola przez 24 godzin</li>
              <li>jednorazowy koszt zakupu lub miesięczny leasing</li>
              <li>niski koszt eksploatacji podtrzymywany UPS</li>
              <li>oszczędność i wygoda dla pracodawcy, brak etatów</li>
              <li>udogodnienie dla osób niepełnosprawnych</li>
            </ul>
          }
        />
        <hr />
        <ImgRight
          image={imageSection2}
          header={
            <div>
              e-Szatnia nie wymaga własnego pomieszczenia. <br />
              <p className="orange-color bradley-text">
                Wystarczy aneks lub szerszy korytarz.
              </p>
            </div>
          }
          text={
            "Dzięki temu może powstać tam, gdzie do tej pory nie było dla niej miejsca. To rozwiązanie pozwala też na oszczędność miejsca, a także na wykorzystanie istniejącego pomieszczenie tradycyjnej szatnię do innych celów i funkcji. Indywidualny projekt szatni zapewni, że będzie ona dostępna i bezpieczna."
          }
        />
        <hr />
        <ImgLeft
          image={imageSection3}
          header={
            <div>
              e-Szatnia składa się dwóch modułów. <br />
              <p className="orange-color bradley-text">
                Stanowisko centralne i szafka depozytowa.{" "}
              </p>
            </div>
          }
          text={
            "Na stanowisku centralnym znajduje się komputer połączony z zamkiem w każdej szafce, zarządza on polityką otwierania i zamykania zamków szafek w oparciu instrukcję z ekranu dotykowego i czytnika kodów. Aplikacja służy do szybkiego i prostego zarządzania samoobsługową szatnią automatyczną udostępnianą osobą trzecim w celu przechowania dóbr osobistych na krótki okres czasu. Istnieje też możliwość wielokrotnego korzystania z tej samej szafki na podstawie tego samego klucza."
          }
        />
        <hr />

        <ImgRight
          image={imageSection4}
          header={
            <div>
              e-Szatnia to prosta i szybka samoobsługa. <br />
              <p className="orange-color bradley-text">
                Jednorazowy bilet i niski koszt eksploatacji.
              </p>
            </div>
          }
          text={
            "Ekran dotykowy oraz przejrzyste komunikaty pozwalają na łatwą i intuicyjną samoobsługę. Kluczem otwierającym szafkę jest wydrukowany każdorazowo, na papierze termicznym kod kreskowy, który po wykorzystaniu staje się nieaktualny. Rozwiązanie to eliminuje problem dystrybucji i przechowywania tradycyjnych kluczy. Dodatkowo po wyborze numeru i odebraniu klucza, udajemy się do konkretnej szafki, zwalniając miejsce następnej osobie i tym samym zapobiegając powstawaniu kolejki. Takie rozwiązanie pozwala na niski koszt eksploatacji. Koszt 300 kluczy to około 1 zł."
          }
        />
        <hr />
        <ImgLeft
          image={imageSection5}
          header={
            <div>
              e-Szatnia zapewnia bezpieczeństwo i pełną kontrolę. <br />
              <p className="orange-color bradley-text">
                Wielofunkcyjny panel administracyjny.
              </p>
            </div>
          }
          text={
            "System posiada dodatkowy tryb panelu administratora, który posiada szereg opcji ułatwiających kontrolę i zarządzanie całą szatnią. Korzystając z odpowiedniego kodu, administrator może w każdej chwili otworzyć dowolną lub wszystkie szafki na raz w celu kontroli ich zawartości. Istnieje też możliwość czasowego wyłączenia jednej lub grupy szafek. Dla zapewniania bezpieczeństwa użytkowania szatnia posiada system podtrzymania UPS zapewniający pracę przy braku zasilania. Dodatkowe zaprojektowaliśmy możliwość awaryjnego otwierania ręcznego przez administratora. "
          }
        />
        <hr />
        <ImgRight
          image={imageSection6}
          header={
            <div>
              e- Szatnie zapewnia indywidualną aranżację. <br />
              <p className="orange-color bradley-text">
                Dowolność materiałów i różnorodność funkcji.
              </p>
            </div>
          }
          text={
            "Styl i kolorystyka można dopasowana do istniejącego wnętrza. Elementy szatni mogą być wykonane z płyt meblowych, płyt MDF foliowanych, laminowanych i lakierowanych. Centrala i szafki mogą być metalowe: lakierowane proszkowo jak i wykonane ze stali szlachetnej. Istnieje możliwość adaptacji istniejących mebli. Rozbudowy o system komunikatów głosowych i całodobowego nadzoru elektronicznego."
          }
        />
      </div>
    </section>
  );
};

export default services;



// WEBPACK FOOTER //
// ./src/components/Cloackroom/Services/Services.js